const homeRouter = {
    path: "/home",
    name: "/home",
    meta: { title: "登录" },
    component: resolve => require(["@/views/home/Home.vue"], resolve),
};

// 所有上面定义的路由都要写在下面的routers里
const route = [
    homeRouter,
];

// 暴露路由
export default route;


// WEBPACK FOOTER //
// ./src/router/route.js


// WEBPACK FOOTER //
// ./src/router/route.js